import { FieldArray, getIn, useFormikContext } from 'formik'
import AutoCompleteField, { VField } from './Fields'
import { Button } from 'react-bootstrap'
import MaterialIcon from './MaterialIcon'
import { useProvinceList } from '../hooks/province'
import { useToponimiList } from '../hooks/toponimi'
import { API_URL } from '../constants'
import { Cliente } from '../types'
import { useEffect } from 'react'

export default function FormCliente() {
  const { values, setFieldValue, touched, errors, initialValues } = useFormikContext<Cliente>()
  const province = useProvinceList()
  const toponimi = useToponimiList()

  return (
    <div className="row">
      <div className="col-8">
        <VField name="ragione_sociale" label="Ragione sociale" required />
      </div>
      <div className="col-4">
        <VField name="ente_pubblico" label="Ente pubblico" type="checkbox" />
      </div>
      <FieldArray
        name="sedi_write"
        render={(arrayHelpers) => (
          <div>
            {getIn(values, 'sedi_write')?.map((sede: any, index: number) => (
              
              <div key={index} className="row">
                <div className="col-md-12 mb-3">
                  <div className="w-100 bg-secondary-body p-2 d-flex align-items-center justify-content-between">
                    <h5 className="heading-h5 mb-0">
                      {sede.sede_principale
                        ? 'Sede principale'
                        : `Sede aggiuntiva ${index + 1}`}
                    </h5>
                    {index > 0 && sede?.can_delete && (
                      <Button
                        size="sm"
                        type="button"
                        className="d-flex align-items-center justify-content-center"
                        variant="outline-danger"
                        onClick={() => arrayHelpers.remove(index)}
                      >
                        <MaterialIcon icon="delete" className="me-2" />
                        Elimina sede
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <VField
                    name={`sedi_write.${index}.numero_rea`}
                    label="Numero REA"
                    required={!values.ente_pubblico}
                  />
                </div>
                <div className="col-md-3">
                  <VField
                    name={`sedi_write.${index}.partita_iva`}
                    label="Partita IVA"
                  />
                </div>
                <div className="col-md-3">
                  <VField
                    name={`sedi_write.${index}.codice_fiscale`}
                    label="Codice fiscale"
                    required={values.ente_pubblico}
                  />
                </div>
                <div className="col-md-2">
                  <VField
                    name={`sedi_write.${index}.unita_locale`}
                    label="Unita locale"
                    
                  />
                </div>
                <div className="col-md-3">
                  <VField
                    name={`sedi_write.${index}.toponimo`}
                    label="Toponimo"
                    required
                    as="select"
                  >
                    <option value="">Seleziona un toponimo</option>
                    {toponimi?.data?.map((toponimo) => (
                      <option key={toponimo.id} value={toponimo.id}>
                        {toponimo.nome}
                      </option>
                    ))}
                  </VField>
                </div>
                <div className="col-md-6">
                  <VField
                    name={`sedi_write.${index}.via`}
                    label="Via"
                    required
                  />
                </div>
                <div className="col-md-2">
                  <VField name={`sedi_write.${index}.civico`} label="Civico" />
                </div>
                <div className="col-md-6">
                  <AutoCompleteField
                    name={`sedi_write.${index}.comune`}
                    label="Comune"
                    required
                    onChange={(value) => {
                      if (value === null) {
                        setFieldValue(`sedi_write.${index}.comune`, undefined)
                        setFieldValue(`sedi_write.${index}.provincia`, undefined)
                        return
                      } 
                      setFieldValue(`sedi_write.${index}.comune`, value?.value)
                      setFieldValue(
                        `sedi_write.${index}.provincia`,
                        value?.provincia_pk
                      )
                    }}
                    url={`${API_URL}/bilance/comune/options`}
                    value={sede.comune}
                  />
                </div>
                <div className="col-md-2">
                  <VField
                    name={`sedi_write.${index}.provincia`}
                    label="Provincia"
                    as="select"
                    required
                  >
                    <option value="">Seleziona una provincia</option>
                    {province?.data?.map((provincia) => (
                      <option key={provincia.id} value={provincia.id}>
                        {provincia.sigla}
                      </option>
                    ))}
                  </VField>
                </div>

                <div className="col-md-4">
                  <VField
                    name={`sedi_write.${index}.nazione`}
                    label="Nazione"
                    required
                  />
                </div>
                <div className="col-md-5">
                  <VField
                    name={`sedi_write.${index}.telefono`}
                    label="Telefono"
                  />
                </div>
                <div className="col-md-4">
                  <VField
                    name={`sedi_write.${index}.email_referente`}
                    label="Email referente"
                  />
                </div>
                <div className="col-md-4">
                  <VField
                    name={`sedi_write.${index}.nome_referente`}
                    label="Nome referente"
                  />
                </div>
              </div>
            ))}
            <Button
              type="button"
              className="d-flex align-items-center mt-3 mb-3"
              variant="outline-secondary"
              onClick={() =>
                arrayHelpers.push({
                  via: '',
                  comune: undefined,
                  toponimo: undefined,
                  civico: '',
                  provincia: undefined,
                  telefono: '',
                  email_referente: '',
                  codice_fiscale: '',
                  nome_referente: '',
                  partita_iva: '',
                  numero_rea: '',
                  nazione: 'ITALIA',
                  can_delete: true,                
                })
              }
            >
              <MaterialIcon icon="add" className="me-2" />
              Aggiungi sede
            </Button>
          </div>
        )}
      />
    </div>
  )
}
